import { DatesDisplay, Flex, LocationDisplay, Text } from 'components'
import { useRef } from 'react'
import { useBreakpoint } from 'utils'
import { useEvent } from '../../../utils'
import EventBannerActionButtons from './EventBannerActionButtons'
interface Props {
  expanded?: boolean
}

export default function EventBannerTitleBar({ expanded }: Props) {
  const { event } = useEvent()
  const textRef = useRef<HTMLParagraphElement>(null)
  const breakpoint = useBreakpoint()

  if (!event) return null

  const { endTime, location, startTime, title } = event

  return (
    <Flex justify="space-between" flex={1}>
      <Flex direction="column" overflow="hidden" gap={1}>
        <Text ref={textRef} textStyle={expanded ? 'h3' : 'h6'} lineClamp={1}>
          {title ? title : '--'}
        </Text>
        <Flex columnGap={5} rowGap={1} opacity={0.6} wrap="wrap">
          <DatesDisplay
            startTime={startTime}
            endTime={endTime}
            textProps={{ textStyle: expanded ? 'bodySmall' : 'bodyXSmall', opacity: 1 }}
          />
          <LocationDisplay
            location={location}
            textProps={{ textStyle: expanded ? 'bodySmall' : 'bodyXSmall', opacity: 1 }}
          />
        </Flex>
      </Flex>

      {expanded && breakpoint >= 3 && <EventBannerActionButtons />}
    </Flex>
  )
}
